import styled from 'styled-components';
import {defaultTheme, textSizes} from '@stencil/build-theme';
import {
  FlexCentered,
  ButtonBase,
} from '../../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

export const BookingWidgetStyleContainer = styled.div<{background?: boolean}>(
  props => `
  border-radius: ${props.theme.misc.borderRadius.xxxlarge};
  padding:${props.theme.spacing.custom(19)} ${props.theme.spacing.custom(8)};
  border: 1px solid #E4E4E4;
  background:${props?.background ? 'linear-gradient(180deg, rgba(255, 255, 255, 0) 35%, #ffebd5d1 109.74%)' : ''};
`,
);

export const PriceStartsAtText = styled.p`
  ${textSizes.BaseW3}
  padding: 0 ${props => props.theme.spacing.base};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const PriceInfo = styled.div(
  props => `
  display: flex;
  // height:${props.isEntireProperty ? '9rem' : 'rem'};
  padding: 0 0.8rem;
`,
);

export const Column = styled.div(
  props => `
  ${props.isAlignEnd ? `>div{justify-content:end}` : ''};
  ${props.isRow ? `display:flex;margin-top:10px` : `width: 50%;`};
  ${props.isEntireProperty && `flex-direction:column`};
`,
);

export const PriceValueStyled = styled.p(
  props => `
  display: inline-flex;
  font-size:${props.theme.font.custom(22)};
  font-weight: 600;
`,
);

export const PriceValue: React.FC<{price?: number}> = ({price}) => (
  <PriceValueStyled>{price}</PriceValueStyled>
);

export const plusPriceRupeeIconProps = {
  fill: defaultTheme.colors.downriver.base,
  width: '0.8rem',
  height: '0.8rem',
};

export const PlusPriceValueText = styled.p(
  props => `
    display: inline-flex;
    color: #717171;
  `,
);

export const PlusPriceValue: React.FC<{price: number}> = ({price}) => (
  <PlusPriceValueText>{price} taxes & fees</PlusPriceValueText>
);

export const PerRoomPerNightLabel = styled.p(
  props => `
  display: flex;
  color: #717171;
  justify-content: end;
  margin-bottom:10px;

  ${
    props.isEntireProperty &&
    `flex-direction:column;
    align-items:flex-end;
  `
  }
`,
);

export const NoOfGuestsContainer = styled(FlexCentered)(
  props => `
  padding: 0 0 ${props.theme.spacing.small} 0;
`,
);

export const NoOfRoomsContainer = NoOfGuestsContainer;

export const NoOfGuestsAndRoomsTextStyles = styled.p(
  props => `
  font-size:${props.theme.font.custom(14)};
  padding-left: ${props.isEntireProperty ? '0.6rem' : `0.5rem`}
`,
);

export const RightDoubleArrowIconContainer = styled.div`
  transform: rotate(90deg) translateX(8px);
  display: inline-block;
  position: relative;
  top: -0.5rem;
  left: 0.5rem;
`;

export const ViewRoomOptionsButton = styled(ButtonBase)(
  props => `
  padding: ${props.theme.spacing.small} ${props.theme.spacing.large} ${props.theme.spacing.base};
  height:4.7rem;
  width:100%;
  border-radius: ${props.theme.misc.borderRadius.custom(8)};
`,
);

export const RoomAndPersuasionContainer = styled.div`
  display: flex;
  align-items: baseline;
  width: 75%;
  flex-direction: column;
`;

export const PersuasionContainer = styled.div`
  margin-bottom: 10px;
`;
